import { render, staticRenderFns } from "./AdminRoleManager.vue?vue&type=template&id=32d3db4e&"
import script from "./AdminRoleManager.vue?vue&type=script&lang=js&"
export * from "./AdminRoleManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports